export class DiagnosticTest {
  dt?: string;
  firstname?: string;
  coding_id?: number;
  user_id?: number;
  patient_id?: number;
  description?: string;
  version_id?: number;
  value?: string;
  version_dt?: string;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
